import { render, staticRenderFns } from "./replace-card.vue?vue&type=template&id=c728d608&scoped=true"
import script from "./replace-card.vue?vue&type=script&lang=ts"
export * from "./replace-card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c728d608",
  null
  
)

export default component.exports